import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loose_graphics/clarity/si1.svg")